module.exports = __webpack_public_path__ + "img/Dahlberg-10.65e27c9e.jpg";